const defaultOptions = {
  // if false, this prevents the popup from showing (useful for giving to control to another piece of code)
  enabled: true,

  // defaults cookie options - it is RECOMMENDED to set these values to correspond with your server
  cookie: {
    // This is the name of this cookie - you can ignore this
    name: 'cvt_cookieconsent',

    // This is the domain that the cookie 'name' belongs to. The cookie can only be read on this domain.
    // Set this to empty string will use current domain, which should be suitable for most use cases,
    // unless sibling subdomains are in concern.
    //  - Guide to cookie domains - http://erik.io/blog/2014/03/04/definitive-guide-to-cookie-domains/
    domain: '',

    // This is a additional identifier for client app to differentiate apps under same domain.
    // eg. construct an event/account specific string if cookie consent is desired for each event or account.
    // NOTE: must not contain control/separator character. eg (CTL), space, tab, or ( ) < > @ , ; : \ " /  [ ] ? = { }
    identifier: '',

    // The cookies expire date, specified in days (specify -1 for no expiry)
    expiryDays: 365
  },

  // desired language for Cven Privacy Policy
  // accept language code, language-contry code, or MS language ID, according to RFC 3066,
  // NOTE: this is REQUIRED
  language: undefined,

  // each item defines the inner text for the element that it references
  // library does not provide default text as of now, client app should provide text with proper translation
  content: {
    // message: 'eg. We use cookies to provide you with a great browsing experience. By using Cvent, ' +
    //   'you accept our use of cookies for analytics and personalized content.',
    // dismiss: 'eg. Accept',
    // allow: 'eg. Accept',
    // deny: 'eg. Decline',
    // link: 'eg. Cvent Privacy Policy',
    href: 'http://www.cvent.com/en/privacy-policy.shtml#cookies', // default page with language selection
    close: '\uE935'
  },

  // select your type of popup here
  type: 'info', // refers to `compliance` (in other words, the buttons that are displayed)

  // this refers to the popup windows position. we currently support:
  position: 'bottom', // default position is 'bottom'

  // cookieconsent library internal theme options
  theme: 'classic', // default classic theme gives border radius

  // if you want custom colours, pass them in here. this object should look like this.
  // if prefered, any custom colours/themes can be created in a separate style sheet, as this is more efficient.
  //   {
  //     popup: {background: '#000000', text: '#fff', link: '#fff'},
  //     button: {background: 'transparent', border: '#f8e71c', text: '#f8e71c'},
  //     highlight: {background: '#f8e71c', border: '#f8e71c', text: '#000000'},
  //   }
  // `highlight` is optional and extends `button`. if it exists, it will apply to the first button
  // only background needs to be defined for every element. if not set, other colors can be calculated from it
  palette: {
    popup: {
      background: '#E9EDEF',
      text: '#3b4d54',
      link: '#0099e0'
    },
    button: {
      background: '#0099e0',
      text: '#f4f8f9'
    }
  },

  /**
   * call backs when user perform action (click button or auto dismiss)
   * valid cookie values
   * cc.status = {
   *   deny: 'deny',
   *   allow: 'allow',
   *   dismiss: 'dismiss'
   * };
  */
  onStatusChange: function onStatusChange(status, chosenBefore) {}, // eslint-disable-line no-unused-vars

  // Some countries REQUIRE that a user can change their mind. You can configure this yourself.
  // Most of the time this should be false
  revokable: false,

  // used to disable link on existing layouts
  // replaces element messagelink with message and removes content of link
  showLink: true,

  elements: {
    messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}}<br />' +
      '<a role=button tabindex="0" class="cc-link" href="{{href}}" ' +
      'rel="noopener nofollow" target="_blank">{{link}}</a></span>'
  },

  // layout options: 'basic': plain, 'basic-close': with close icon, 'basic-header': with header
  layout: 'basic-close',

  // dismiss banner when user click anything
  dismissOnWindowClick: true, // default to be true

  // The application automatically decide whether the popup should open.
  // Set this to false to prevent this from happening and to allow you to control the behaviour yourself
  autoOpen: true
};

export default defaultOptions;
